import { useEffect, useState } from "react";
import { Paper, Button, Table, TableBody, Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { globalDeleteService, globalGetService } from "../../../../utils/globalApiServices";
import { DeletePopUp, PageLoader, Pagination, STableLoader } from "../../../../shared_elements";
import SettingNav from "../../../elements/SettingNav";
import ClauseCRU from "../components/ClauseCRU";
import ClauseList from "../components/ClauseList";
import NoRecordFound from "../../../../shared_elements/NoRecordFound";
import { checkApiStatus } from "../../../../utils";
import { getClauseListApi, deleteClauseApi } from "../apiServices";
import { LeasesMenuList } from "../../../elements";
import { PermissionWrapper } from "../../../../wrappers";
import { RoleBaseAccess } from "../../../../hoc";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { ButtonLoader } from "../../../../shared_elements/components";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { trackActivity } from "../../../../utils/mixpanel";
import ModuleWiseRevisionHistory from "../../../../shared_elements/components/ModuleWiseRevisionHistory";
import BackToLeaseList from "../../../elements/BackToLeaseList";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const ClauseHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Clause`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "induction_conditions", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}> {tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}> {tableSorting('asset_type', 'Asset Type')}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}> {tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    )
}

const Clause = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [clauseInfo, setClauseInfo] = useState({ list: [], pagination: {} });
    const [clauseCRU, setClauseCRU] = useState({ modal: false, data: null, mode: '' });
    const [deletClause, setDeleteClause] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const[isExport,seIsExport]=useState(false)

    useEffect(() => {
        getClauseList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Clause' })
    }, [])

    const toggleBulkOps = (flag, type, item) => {
            if (type === 'bulk') {
                setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
            } else {
                setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
            }
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getClauseList('pageLoader', { ...sortQuery, per_page: clauseInfo?.pagination?.per_page });
    }

    const getClauseList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getClauseListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                setClauseInfo(response.data.data);
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
    }

    const deleteClauseFn = () => {
        setLoading(true);
        const idsToDelete = deletClause?.modal && deletClause?.data?.id ? [deletClause?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteClauseApi(), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Clause`, success_msg: response?.data?.message, item_ids: deletClause?.data || bulk?.ids, response: response?.data })
                    setDeleteClause({ modal: false, data: null });
                    getClauseList('', { per_page: clauseInfo?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], title: '', type: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Clause`, error_msg: response?.data?.message, item_ids: deletClause?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const handleExport = () => {
       let query = { export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = {
        ...query,
        sort: sortInfo?.sort,
        sort_by: sortInfo?.sort_by
      }
    }
        seIsExport(true);
        globalGetService(getClauseListApi(query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
            }
            seIsExport(false);
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Clause`, page_type: page_type, })
    }

    return (
        <Paper className="setting_details_section lease-details-section lease-module-paper" elevation={0}>
            <SettingNav />
            <div className="lease-details-content">
                <Paper className="responsive-paper">
                    <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                        <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                            <BackToLeaseList/>
                        </Grid>
                        <Grid item size={{ md: 8, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'5px 0px' }}>
                                <li className='lease-mobile-button revision-history'>
                                    <ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} />
                                </li>
                                {
                                    bulk?.type && bulk?.ids?.length ?
                                        <>
                                            <li className='lease-mobile-button'>
                                                <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                            </li>
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "induction_conditions", operationType: ['D'] }}>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper>
                                        </> : null
                                }
                                {clauseInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button className='btn-primary action-btn-start-icon' startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "induction_conditions", operationType: ['C'] }}>
                                    <li className='lease-mobile-button'> <Button variant="contained" color="primary" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setClauseCRU({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Clause </Button> </li>
                                </PermissionWrapper>
                            </ul>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper className="lease-detail-table table-container lease-module-paper" elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 138px)', height: clauseInfo?.list?.length > 0 ? 'calc(100vh - 138px) !important' : 'auto !important', }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <ClauseHd
                                    item={clauseInfo?.list}
                                    bulk={bulk}
                                    toggleBulkOps={toggleBulkOps}
                                    sortInfo={sortInfo}
                                    createSortHandler={createSortHandler} />
                                <TableBody>
                                    {clauseInfo?.list?.length > 0 && clauseInfo?.list?.map((item, index) =>
                                        <ClauseList
                                            key={index}
                                            item={item}
                                            bulk={bulk}
                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                            onEditFn={() => setClauseCRU({ modal: true, data: item, mode: 'edit' })}
                                            onView={() => setClauseCRU({ modal: true, data: item, mode: 'view' })}
                                            ondeleteClauseFn={() => {
                                                setDeleteClause({ modal: true, data: item, });
                                                setBulk({modal: false, ids: [item], title: '', type: ''});
                                            }}
                                            toggleBulkOps={toggleBulkOps}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && clauseInfo?.list?.length === 0 && <NoRecordFound />}
                    </div>
                    <Paper square>
                        <Pagination
                            pagination={clauseInfo?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getClauseList("pageLoader", { page: pageNum, per_page: clauseInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getClauseList("pageLoader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        />
                    </Paper>
                </Paper>
            </div>
            {clauseCRU.modal &&
                <ClauseCRU
                    clauseCRU={clauseCRU}
                    modeType={clauseCRU?.mode}
                    getResponseBack={() => {getClauseList("", { per_page: clauseInfo?.pagination?.per_page }); setBulk({modal: false, ids: [], title: '', mode: ''})}}
                    onToggleModal={() => setClauseCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {deletClause.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deletClause.modal}
                    title={bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (clauseInfo?.list?.length || 0)) ? "Delete All Clauses" : "Delete Selected Clause" : "Delete Clause" }
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : (setDeleteClause({ modal: false, data: null }), setBulk({ modal: false, ids: [], title: '', type: '' })) }
                    onDeleteRecords={() => deleteClauseFn()}
                /> : null}
            {isLoading ? <PageLoader /> : null}

            {
                revisionHistory.modal &&  
                <RevisionHistory 
                 moduleName={"condition_clause"}
                 revisionHistory={revisionHistory}
                 onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
               />
            }

        </Paper>
    )

};

export default RoleBaseAccess(Clause, { application: 'lease_revamp', feature: 'induction_conditions', operationType: ['R'] });
